/**
 * Represents a part of a question, containing various properties and methods to manage its state and behavior.
 */
import RepositoryEntry from './RepositoryEntry';
class QuestionPart extends RepositoryEntry {
    /**
     * Constructs a new QuestionPart instance.
     * @param {Object} entry - Initial data to populate the QuestionPart.
     */
    constructor(entry, $injector) {
        super(entry, $injector);
        entry.attachment = undefined;

        /**
         * Properties that are readable.
         * @type {Object}
         */
        this.readables({
            // 'marks': Number,
            'shortTitle': String,
            'useCustomTitle': Boolean,
            'type': String
        });

        /**
         * Properties that are accessible.
         * @type {Object}
         */
        this.accessables({
            'title': String,
            'bookmarked': Boolean,
            'status': Number,
            'attachment': Object,
            'spoiled': Boolean,
            'marks': Number,
            'ibisID': Number
        });

        /**
         * References to other objects.
         * @type {Object}
         */
        this.references({
            'questionItemGroup': Object,
            'criterionMarks': Object
        });

        /**
         * Validators for the QuestionPart.
         * @type {Object}
         */
        this.validators({
            'QPResponsePDFValidator': 'QPResponsePDFValidator',
            'QIGEmptyQPValidator': 'QIGEmptyQPValidator',
            'QuestionPartMarksValidator': 'QuestionPartMarksValidator',
            'OrderQuestionPartValidator': 'OrderQuestionPartValidator'
        });

    }

    /**
     * Returns a string representation of the status of the QuestionPart.
     * @returns {string} - 'not-started' if status is 0, otherwise 'completed'.
     */
    getStatusString() {
        let state = this.getStatus(),
            result = 'not-started';

        if (state !== 0) {
            result = 'completed';
        }

        return result;
    }

    /**
     * Determines if the title should be displayed.
     * @returns {boolean} - True if the title should be displayed, otherwise false.
     */
    shallDisplayTitle() {
        let isVisible = true;

        if (this.data.showTitle !== undefined) {
            isVisible = this.data.showTitle;
        }

        return isVisible;
    }

    /**
     * Cleans up the attachment object before saving by removing undefined or empty properties.
     */
    onBeforeSave() {
        let attachment = this.data.attachment,
            obsoleteKeys = [],
            key;

        if (typeof attachment !== 'undefined') {
            for (key in attachment) {
                if (typeof attachment[key] === 'undefined' || attachment[key] === '') {
                    obsoleteKeys.push(key);
                }
            }

            for (let idx in obsoleteKeys) {
                let key = obsoleteKeys[idx];
                delete attachment[key];
            }
        }
    }
}

export default QuestionPart;